export function stripProps(props) {
    return {
        value: props.value || '',
        onChange: props.onChange,
        onBlur: props.onBlur,
        name: props.name
    };
}


// WEBPACK FOOTER //
// ./js/shared/stripCorrectProps.js